import React from 'react';
import PropTypes from 'prop-types';
import { BsChevronRight } from 'react-icons/bs';
import CardHeader from '../../card-header';
import Input from '../../input';
import styles from './fund.module.css';
import ButtonSectionCard from '../../button-section-card';
import { useDispatch, useSelector } from 'react-redux';
import { setSearch } from 'store/graph/actions';
import ReactTooltip from 'react-tooltip';
import { CharitableIcon } from 'common/icon/icon';
import { selectIsContextIdsEmpty } from 'store/graph/selectors';
import LastUpdated from 'common/last-updated';

const FundCard = ({ properties, showForModal = false }) => {
  const {
    institution,
    college,
    department,
    fundName,
    purpose,
    tedUrl,
    nodeKey,
    region,
    ingestionDateUtc,
    isContextNode,
  } = properties;
  const dispatch = useDispatch();
  const showShortestPath = useSelector(selectIsContextIdsEmpty);
  const setAsAContext = (e) => {
    if (e && e.preventDefault) e.preventDefault();
    dispatch(
      setSearch({
        displayValue: fundName,
        id: nodeKey,
        metroRegion: region,
        label: 'fund',
        type: 'vertex',
        value: fundName,
      }),
    );
  };

  return (
    <div className={styles.card}>
      <CardHeader
        value="Fund"
        showShortestPath={!showShortestPath}
        icon={<CharitableIcon className={styles.charitable_icon} />}
        nodeId={nodeKey}
        isContextNode={isContextNode}
        name={fundName}
        showForModal={showForModal}
      />
      <div className={styles.content}>
        <div className={styles.content_header}>
          <div className={styles.left_section}>
            <div className={styles.name}>
              <h2 className={styles.name_desc}>{fundName}</h2>
              <BsChevronRight
                data-tip
                data-for={nodeKey}
                className={styles.name_icon}
                onClick={setAsAContext}
              />
              <ReactTooltip id={nodeKey} place="top" effect="solid">
                Add as a search context
              </ReactTooltip>
            </div>
            <div className={styles.person_details_wrapper}>
              <div className={styles.person_details_title}>Institution:</div>
              <div className={styles.person_details_value}>{institution}</div>
            </div>
            <div className={styles.person_details_wrapper}>
              <div className={styles.person_details_title}>College:</div>
              <div className={styles.person_details_value}>{college}</div>
            </div>
            <div className={styles.person_details_wrapper}>
              <div className={styles.person_details_title}>Department:</div>
              <div className={styles.person_details_value}>{department}</div>
            </div>
          </div>
          <LastUpdated ingestionDateUtc={ingestionDateUtc} />
        </div>
        <div className={styles.affiliation_unit}>
          <Input value={purpose} label="Purpose" />
        </div>
      </div>
      <ButtonSectionCard tedUrl={tedUrl} />
    </div>
  );
};

FundCard.propTypes = {
  fund: PropTypes.object,
};

export default FundCard;
